import { useMutation } from "react-query";
import { queryClient } from "services/queries";
import { postResetPassword } from "../requests/Login";

export function useMutationResetPassword() {
    const query = useMutation(postResetPassword, {
        onSuccess: (data) => {
            if(data?.success) {
                // return data;
            } else {
                // console.log(data?.errors)
            }
        }, onError: (data) => {
            // console.error(data)
        }
    });
    return query;
}
